export const displayFormat = 'EEE MMM d';

export const defaultDateInputFormats = [
  'MM/dd/yy', // 1/03/19, 1/31/19, 1/3/19
  'MM/dd/yyyy', // 1/03/2019, 1/31/2019, 1/3/2019
  'MMMM dd yyyyy', // Jan 4 2019, jan 4 2019, Jan. 4, 2019, Jan. 04, 2019, January 4 2019
  'dd MMMM yyyyy', // 1 Nov 2020, also accepts 1 nov 2020 and 5 jan., 2019
  'yy-MM-dd', // 19-01-11
  'yyyyy-MM-dd', // 2019-01-11
  'EEEE MMMM dd yyyyy', // thursday jan 3 2019, mon jan 7 2019, m jan 7 2019, mo jan 7 2019
  'MMMM dd', // nov 2, Nov 2, Nov. 2, Nov 02, November 2 (year is provided based on context)
  'dd MMMM', // 2 nov, 2 Nov, 2 Nov., 02 Nov, 2 November (year is provided based on context)
  'MM/dd', // 11/02 (year is provided based on context)
  'M/d', // 9/3 (year is provided based on context)
];
